/**
 * V2 Paywall Media Section Configuration
 *
 * V2 version of paywallMediaSectionConfig.ts with V2 data paths.
 * Media content in content.featuredMedia, gradient/body overlay in content.paywall.bodyAppearance.
 *
 * V2 path mapping:
 * - V1 media → V2 content.featuredMedia
 * - V1 styles.bodyStyle → V2 content.paywall.bodyAppearance.overlay
 * - V1 styles.imageVerticalPosition → V2 content.paywall.bodyAppearance.heroAnchor (legacy fallback)
 *
 * Sprint: schema-v2-migration, Sprint 4
 */

import type { FieldConfig } from '../types/editorFieldTypes';
// Re-export media defaults from existing V2 media config
export { V2_DEFAULT_MEDIA_STRUCTURE } from './v2MediaConfig';

// ============================================
// Gradient Configuration (V2 paths)
// ============================================

export const V2_DEFAULT_GRADIENT_STRUCTURE = {
  colors: ['#000000', '#00000000'],
  locations: [0, 1],
  startPoint: { x: 0.5, y: 1 },
  endPoint: { x: 0.5, y: 0 },
  kind: 'GradientKind1',
  heightPercentage: 50,
};

export const V2_PAYWALL_GRADIENT_ENABLE_CONFIG: FieldConfig = {
  path: 'content.paywall.bodyAppearance.overlay',
  label: 'Gradient',
  type: 'toggle',
  defaultValue: null,
  disableBehavior: 'null',
  guideKey: 'screenedit-paywall-media-gradient',
};

export const V2_PAYWALL_GRADIENT_HEIGHT_CONFIG: FieldConfig = {
  path: 'content.paywall.bodyAppearance.overlay.heightPercentage',
  label: 'Height',
  type: 'slider',
  defaultValue: 50,
  min: 0,
  max: 100,
  step: 5,
  isNullable: false,
  guideKey: 'screenedit-paywall-media-gradient-height',
};

export const V2_PAYWALL_GRADIENT_COLOR_CONFIG: FieldConfig = {
  path: 'content.paywall.bodyAppearance.overlay.colors.0',
  label: 'Color',
  type: 'color',
  defaultValue: '#000000',
  isNullable: false,
  guideKey: 'screenedit-paywall-media-gradient-color',
};

export const V2_PAYWALL_GRADIENT_CONFIGS: FieldConfig[] = [
  V2_PAYWALL_GRADIENT_ENABLE_CONFIG,
  V2_PAYWALL_GRADIENT_HEIGHT_CONFIG,
  V2_PAYWALL_GRADIENT_COLOR_CONFIG,
];
